import createEvent from '@/helpers/createEvent';

const closeIcon = `
  <svg class="icon icon-times icon--xs color-primary ml-4" aria-hidden="true">
    <use xlink:href="#icon-times"></use>
  </svg>
`;

export const getInputForKeyAndValue = (key, val) => {
  const input = document.querySelector(`[name="${key}"]`);

  if (!input) {
    return null;
  }

  if (input.type === 'checkbox' || input.type === 'radio') {
    return document.querySelector(`[name="${key}"][value="${val}"]`);
  }

  return input;
};

export const getLabelTextForInput = (key, val) => {
  const input = getInputForKeyAndValue(key, val);

  if (!input) {
    return null;
  }

  const label = input.getAttribute('data-label');

  if (!label) {
    return null;
  }

  if (input.tagName === 'SELECT') {
    const selectedOptionText = input.selectedOptions[0].text;
    return label.replace('[value]', selectedOptionText);
  }

  return label.replace('[value]', val);
};

export const renderSelectedFilterButton = (filter) => `
  <button
    type="button"
    class="selected-filters__button btn--reset"
    data-name="${filter.key}"
    data-value="${filter.value}"
    data-action="filters#onFilterRemove"
  >
    ${filter.label} ${closeIcon}
  </button>
`;

export const renderResetFilterButton = `
  <button
    type="button"
    class="color-primary text-underline lg-font-size-lg btn--reset"
    data-action="filters#onFilterReset"
  >
    Reset filters
  </button>
`;

export const getDefaultForInput = (input) => input.getAttribute('data-default');

export const removeFilter = (key, value) => {
  const input = getInputForKeyAndValue(key, value);
  const defaultValue = getDefaultForInput(input);

  if (defaultValue) {
    input.value = defaultValue;
  } else if (input.type === 'checkbox' || input.type === 'radio') {
    input.checked = false;
  } else {
    input.value = '';
  }

  createEvent(input, 'change');
};

export const removeFilterForButton = (button) => {
  removeFilter(button.getAttribute('data-name'), button.getAttribute('data-value'));
};
